import { AUTH_TOKEN_COOKIE_NAME, OLD_TOKEN_COOKIE_NAME } from "@/models/auth/types";
import { isClient, onlyClient } from "@/utils";

const clientAuthStore = onlyClient<{ accessToken: string | null }>({ accessToken: null });

const getClientAccessToken = (): string | null => {
  return clientAuthStore.accessToken || null;
};

export const setClientAccessToken = (accessToken: string | null) => {
  clientAuthStore.accessToken = accessToken;
};

/**
 * next/headersを直接importすると、サーバー側しか動かないエラーになるためdynamic importを利用
 *
 * importを使うと関数が非同期になるため、requireを利用
 */
export const getServerAccessToken = (): string | null => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const cookieStore = require("next/headers").cookies();
  const oldToken = cookieStore.get(OLD_TOKEN_COOKIE_NAME)?.value;
  const newToken = cookieStore.get(AUTH_TOKEN_COOKIE_NAME)?.value;
  const accessToken = newToken || oldToken;
  return accessToken || null;
};

/**
 * サーバーサイドでもクライアントサイドでもアクセストークンための関数
 * 認証情報のセットはuseAuth.tsを利用する
 * @returns
 */
export const getAccessToken = () => {
  const accessToken = isClient ? getClientAccessToken() : getServerAccessToken();
  return accessToken;
};
